module.exports = __webpack_public_path__ + "static/coph2-fc314fa19b5780817325ee9853afc4a9.jpg";